// import 'babel-polyfill'
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
import Vue from 'vue'
import Index from './pages/index/index.vue'
import router from './router'
import store from './store'
import xVueUI from '@xue5hen/x-vue-ui/lib/xVueUI.common.js'
import '@xue5hen/x-vue-ui/lib/xVueUI.css'
import ElementUI from 'element-ui'
import './assets/styles/reset.less'
import './assets/styles/index.less'
import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import './assets/styles/font-awesome.css'
import ajax from '@/assets/js/ajax'
import jstools from 'jstools-common/dist/jstools.web'


import "@/assets/js/public.js";

import '@wangeditor/editor/dist/css/style.css'

Vue.config.productionTip = false

Vue.use(xVueUI)
Vue.use(ElementUI)
Vue.use(ajax)

Vue.prototype.$jstools = jstools
Vue.prototype.$confirm = ElementUI.confirm

router.beforeEach((to, form, next) => {
  document.title = to.meta.title || '信息科技'
  if (to.name !== 'login' && !window.localStorage.getItem('token')) {
    ElementUI.MessageBox.alert('登录已失效, 需要重新登录', '错误', {
      confirmButtonText: '确定',
      callback: () => {
        router.push({
          name: 'login'
        });
      }
    });
    return false
  } else {
    next()

  }
})

new Vue({
  router,
  store,
  render: h => h(Index),
}).$mount('#app')
